"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCoins = void 0;

var getCoins = function getCoins(points) {
  return Math.floor(points / 5);
};

exports.getCoins = getCoins;
//# sourceMappingURL=utils.js.map